import React, { useState } from 'react';
import PropTypes from 'prop-types';

export const RocketLogo = ({ baseSize = 42, hoverable = false }) => {
  const [hovering, setHovering] = useState(false);

  const handleHover = () => hoverable && setHovering(true);
  const handleLeave = () => hoverable && setHovering(false);

  const containerStyle = {
    width: baseSize,
    height: baseSize * 1.2,
    overflow: 'visible',
    // overflow: 'hidden',
    display: 'inline-block',
    cursor: hoverable ? 'pointer' : 'default',
  };

  return (
    <div
      className={`a-launch-logo-container ${hovering ? 'launch-active' : ''}`}
      onMouseEnter={handleHover}
      onMouseLeave={handleLeave}
      style={containerStyle}
    >
      <style>
        {`
        .a-launch-logo-container .rocket-component {
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          transition: all 0.3s ease-out;
        }

        .rocket-body-main,
        .rocket-fin,
        .rocket-body-band,
        .rocket-engine-nozzle,
        .rocket-window-frame {
          stroke: #5de6ff;
          filter: drop-shadow(0 0 1.5px rgba(100, 255, 218, 0.5));
        }

        .rocket-window-glass {
          fill: #5de6ff;
          opacity: 0.7;
        }

        .a-launch-logo-container.launch-active .rocket-body-main,
        .a-launch-logo-container.launch-active .rocket-fin,
        .a-launch-logo-container.launch-active .rocket-body-band,
        .a-launch-logo-container.launch-active .rocket-engine-nozzle,
        .a-launch-logo-container.launch-active .rocket-window-frame {
          filter: drop-shadow(0 0 4px #5de6ff)
                  drop-shadow(0 0 10px #5de6ff);
        }

        .a-launch-logo-container.launch-active .rocket-window-glass {
          opacity: 0.9;
          filter: drop-shadow(0 0 5px #5de6ff);
        }

        .rocket-trail {
          stroke: #5de6ff;
          stroke-width: 10;
          opacity: 0;
          transform-origin: 50px 118px;
        }

        .a-launch-logo-container.launch-active .rocket-trail {
          opacity: 1;
          animation: fieryTrail 1s ease-in-out infinite, trailIgnite 0.4s forwards ease-out;
        }

        @keyframes fieryTrail {
          0%, 100% {
            stroke: #5de6ff;
            transform: scaleY(1) scaleX(1);
          }
          50% {
            stroke: #a0fcef;
            transform: scaleY(1.15) scaleX(1.05);
          }
        }

        @keyframes trailIgnite {
          from { transform: scaleY(0.1) scaleX(0.5); opacity: 0.3;}
          to   { transform: scaleY(1) scaleX(1); opacity: 1; }
        }
        `}
      </style>
      <svg
        viewBox="0 0 200 200"
        preserveAspectRatio="xMidYMin meet"
        style={{ display: 'block', overflow: 'visible' }}
      >
        <g id="rocket-assembly" transform="translate(0 80)">
          <path className="rocket-component rocket-trail" d="M 42 118 Q 50 135 58 118 Z" />
          <g id="rocket-main-structure">
            <path className="rocket-component rocket-engine-nozzle" d="M 40 110 L 42 118 L 58 118 L 60 110 Z" />
            <path className="rocket-component rocket-body-main" d="M 50 20 L 30 100 L 40 110 H 60 L 70 100 L 50 20 Z" />
            <path className="rocket-component rocket-body-band" d="M 38 70 H 62" />
            <circle className="rocket-component rocket-window-glass" cx="50" cy="55" r="6" />
            <circle className="rocket-component rocket-window-frame" cx="50" cy="55" r="7" />
            <path className="rocket-component rocket-fin" d="M 30 85 L 15 115 L 35 105 Z" />
            <path className="rocket-component rocket-fin" d="M 70 85 L 85 115 L 65 105 Z" />
          </g>
        </g>
      </svg>
    </div>
  );
};

RocketLogo.propTypes = {
  baseSize: PropTypes.number,
  hoverable: PropTypes.bool,
};
